module.exports = __webpack_public_path__ + "img/about_1998.200a06a1.png";